import React from 'react';
import { IoMdEye } from "react-icons/io";

import RedButton from "../../globalComponents/redButton/RedButton"
import "../../Styles/login/NewLogin.css"

import { useBranding } from "../../config/branding";

const Login = ({ 
    heading,
    heroText,
    showPopUp,
    // setShowPopUp,
    alertText, 
    userEmail, 
    setUserEmail, 
    password, 
    setPassword, 
    showPassword, 
    setShowPassword, 
    handleSubmit, 
    handleSignup,
    submitLoader 
    }) => {
const branding = useBranding();
    
    return (
            <div className='login-new-main-container'>
                <img
                    src={branding.LOGIN_WALLPAPER}
                    className='login-new-left-side-wallpaper'
                    alt='Campus view'
                />
                <div className='login-new-left-overlay' />

                <div className='login-new-center-wrap'>
                    <div className='login-new-right-side-data'>
                        <div className='login-new-top-right-side-logg'>
                            <img
                                src={branding.LOGIN_LOGO}
                                className='login-new-right-top-image'
                                alt={branding.LOGO_ALT_TEXT || 'Company Logo'}
                            />
                        </div>

                        <div className='login-new-heading-block'>
                            <h2>{heading || 'Welcome Back'}</h2>
                            <p>Sign in to continue to {branding.APP_TITLE || 'Proctored Assessment'}.</p>
                            <span className='login-new-org-name'>{heroText || branding.ORG_NAME}</span>
                        </div>

                        <div className='login-new-form-css'>
                            <div className='form-container-new'>
                                <div className='input-div'>
                                    <label htmlFor='userEmail-New'>Email</label>
                                    <div className='input-main'>
                                        <input
                                            id='userEmail-New'
                                            type='email'
                                            placeholder='Enter your email'
                                            value={userEmail}
                                            onChange={(e) => setUserEmail(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='input-div'>
                                    <label htmlFor='password-New'>Password</label>
                                    <div className='input-main'>
                                        <input
                                            id='password-New'
                                            placeholder='Enter your password'
                                            type={!!showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <button
                                            type='button'
                                            className='login-pass-toggle'
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            aria-label='Toggle password visibility'
                                        >
                                            <IoMdEye />
                                        </button>
                                    </div>
                                </div>

                                <div className='login-submit-btn'>
                                    <RedButton
                                        onClickHandler={handleSubmit}
                                        text={'Login'}
                                        loading={submitLoader}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Login;
